import React, { Component } from 'react';
import HowToLayout from './HowToLayout';

class HowToMessages extends Component {
    render() {
        return (
            <HowToLayout title="Messages">
                <p className="howto-intro">
                    The <strong className="howto-strong">Messages</strong> tab is where your conversations live. There are two kinds: one-on-one <strong className="howto-strong">Messages</strong> with other members, and <strong className="howto-strong">Group Messages</strong> that belong to an event. They sit in separate tabs so they're easy to keep apart.
                </p>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Messaging a Member (One-on-One)</h3>
                    <p className="howto-paragraph">
                        Open someone's profile and tap <strong className="howto-strong">Message</strong> to start a private conversation. Whether the button appears depends on their privacy setting — members can choose to receive messages from anyone, only followers, only friends, only premium members, or no one. Your conversations show up under the <strong className="howto-strong">Messages</strong> tab.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Managing a Conversation</h3>
                    <p className="howto-paragraph">
                        Press and hold a conversation to <strong className="howto-strong">Delete Conversation</strong>, <strong className="howto-strong">Block</strong> the person, or <strong className="howto-strong">Report</strong> them. Deleting removes the conversation for you, and blocking ends contact and clears the thread.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Group Messages (Event Chats)</h3>
                    <p className="howto-paragraph">
                        Group Messages belong to events. When the host of an event you're in starts the group chat, it appears under <strong className="howto-strong">Group Messages</strong>, named after the event, so everyone going can coordinate — where to meet, what to bring, who's running late.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>When Group Chats Expire</h3>
                    <p className="howto-paragraph">
                        An event's group chat is temporary. It automatically closes about 24 hours after the event, and you'll see <strong className="howto-strong">"Event ended, group chat expired."</strong> once it does. Anything important is best sorted out before then.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Messages vs Group Messages</h3>
                    <p className="howto-paragraph">
                        Use <strong className="howto-strong">Messages</strong> for a private back-and-forth with one person. <strong className="howto-strong">Group Messages</strong> are shared with everyone in an event's chat and exist just for that event. New messages arrive in real time in both.
                    </p>
                </section>

                <p className="howto-footer-note">
                    Still need a hand? Email <a href="mailto:hello@animates.app" className="howto-link">hello@animates.app</a>.
                </p>
            </HowToLayout>
        );
    }
}

export default HowToMessages;
